document.addEventListener('DOMContentLoaded', function() {
    const accountToggle = document.querySelector('.account-toggle');
    const accountPopup = document.querySelector('#AccountPopup');
    const closeButton = document.querySelector('.account-popup__close');
  
    if (accountToggle && accountPopup) {
      accountToggle.addEventListener('click', function() {
        const isExpanded = accountToggle.getAttribute('aria-expanded') === 'true';
        accountToggle.setAttribute('aria-expanded', !isExpanded);
        accountPopup.hidden = isExpanded;
      });
  
      // Close popup when clicking outside
      document.addEventListener('click', function(event) {
        if (!accountToggle.contains(event.target) && !accountPopup.contains(event.target)) {
          accountToggle.setAttribute('aria-expanded', 'false');
          accountPopup.hidden = true;
        }
      });

      // Close popup when clicking close button
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          accountToggle.setAttribute('aria-expanded', 'false');
          accountPopup.hidden = true;
        });
      }
    }
  });